import Link from 'next/link'
import { useTranslations } from 'next-intl'

import { authLinkClass } from './auth-shell'

/**
 * The sign-in-wrap notice, next to the primary action so the assent is
 * conspicuous (no checkbox), as in the classic form.
 */
export function ConsentLine() {
  const t = useTranslations('encuentro.auth.legal')
  return (
    <p className="text-center text-en-meta text-en-ink-muted">
      {t.rich('consent', {
        terms: (chunks) => (
          <Link href="/policies/terms" target="_blank" className={authLinkClass}>
            {chunks}
          </Link>
        ),
        privacy: (chunks) => (
          <Link href="/policies/privacy" target="_blank" className={authLinkClass}>
            {chunks}
          </Link>
        ),
      })}
    </p>
  )
}
